import { ProgramItem } from '../models/program-item.model';

export class AddProgramItems {
    static readonly type = '[ProgramItem] AddProgramItems';

    constructor(public payload: ProgramItem[]) {}
}
